import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-forest-900 relative overflow-hidden">
      {/* Decorative ripple circles */}
      <div className="absolute right-0 bottom-0 w-96 h-96 rounded-full border border-cream-200/5 translate-x-1/2 translate-y-1/2 pointer-events-none" />
      <div className="absolute right-0 bottom-0 w-64 h-64 rounded-full border border-cream-200/5 translate-x-1/2 translate-y-1/2 pointer-events-none" />
      <div className="absolute right-0 bottom-0 w-32 h-32 rounded-full border border-cream-200/5 translate-x-1/2 translate-y-1/2 pointer-events-none" />

      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12 lg:gap-16">
          {/* Brand */}
          <div className="lg:col-span-1">
            <img
              src="/images/OMFES_letterhed_touka2.png"
              alt="OMFES"
              className="h-12 w-auto object-contain mb-6"
            />
            <p className="text-cream-400 text-xs font-serif leading-relaxed tracking-wider mb-2">
              一般社団法人<br />東洋医学未来推進協会
            </p>
            <p className="text-cream-500/60 text-xs font-serif tracking-widest">
              Oriental Medicine Future Expand Society
            </p>
            <div className="mt-6 pt-6 border-t border-forest-700/50">
              <p className="text-cream-500/60 text-xs leading-relaxed">
                〒101-0041<br />
                東京都千代田区神田須田町一丁目十六ー五<br />
                ヒューリック神田ビル７階
              </p>
              <a
                href="mailto:omfes.info@gmail.com"
                className="mt-3 inline-block text-cream-400/80 text-xs hover:text-cream-200 transition-colors cursor-pointer"
              >
                omfes.info@gmail.com
              </a>
            </div>
          </div>

          {/* Navigation */}
          <div className="lg:col-span-2 grid grid-cols-2 sm:grid-cols-3 gap-8">
            <div>
              <h4 className="text-cream-300 text-xs font-serif tracking-widest2 mb-4 pb-2 border-b border-forest-700/50">
                協会情報
              </h4>
              <ul className="space-y-2">
                {[
                  { label: '協会について', path: '/about' },
                  { label: '設立趣旨', path: '/about#philosophy' },
                  { label: '役員一覧', path: '/about#officers' },
                ].map((item) => (
                  <li key={item.path}>
                    <Link to={item.path} className="text-cream-500/60 text-xs hover:text-cream-300 transition-colors cursor-pointer whitespace-nowrap">
                      {item.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h4 className="text-cream-300 text-xs font-serif tracking-widest2 mb-4 pb-2 border-b border-forest-700/50">
                活動・参加
              </h4>
              <ul className="space-y-2">
                {[
                  { label: '活動内容', path: '/activities' },
                  { label: '入会案内', path: '/membership' },
                  { label: '協賛', path: '/sponsorship' },
                ].map((item) => (
                  <li key={item.path}>
                    <Link to={item.path} className="text-cream-500/60 text-xs hover:text-cream-300 transition-colors cursor-pointer whitespace-nowrap">
                      {item.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h4 className="text-cream-300 text-xs font-serif tracking-widest2 mb-4 pb-2 border-b border-forest-700/50">
                情報
              </h4>
              <ul className="space-y-2">
                {[
                  { label: 'お知らせ', path: '/news' },
                  { label: 'お問い合わせ', path: '/contact' },
                ].map((item) => (
                  <li key={item.path}>
                    <Link to={item.path} className="text-cream-500/60 text-xs hover:text-cream-300 transition-colors cursor-pointer whitespace-nowrap">
                      {item.label}
                    </Link>
                  </li>
                ))}
                <li>
                  <a
                    href="https://www.facebook.com/people/OMFES-東洋医学未来推進協会/61586276497652/"
                    target="_blank"
                    rel="nofollow noopener noreferrer"
                    className="text-cream-500/60 text-xs hover:text-cream-300 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    Facebookページ
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-12 pt-6 border-t border-forest-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-cream-500/40 text-xs font-serif">
            &copy; 2025 一般社団法人東洋医学未来推進協会. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a
              href="https://www.facebook.com/people/OMFES-東洋医学未来推進協会/61586276497652/"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="w-8 h-8 hover:opacity-80 transition-opacity cursor-pointer"
              aria-label="Facebook"
            >
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" className="w-full h-full">
                <rect fill="#1877F2" height="32" rx="4" width="32"/>
                <path d="m18.4 10.5h2.1v-3.5h-2.4c-3 0-4.4 1.4-4.4 4.1v1.9h-2v3.5h2v8.5h3.5v-8.5h2.4l.4-3.5h-2.8v-1.5c0-.7.2-1 1.2-1z" fill="#ffffff"/>
              </svg>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
